import { render, staticRenderFns } from "./MicrocartIcon.vue?vue&type=template&id=22094ecf&scoped=true&"
import script from "./MicrocartIcon.vue?vue&type=script&lang=js&"
export * from "./MicrocartIcon.vue?vue&type=script&lang=js&"
import style0 from "./MicrocartIcon.vue?vue&type=style&index=0&id=22094ecf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22094ecf",
  null
  
)

export default component.exports